import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SharedCapitalsMarketService {
  private dataCapitalsMarketSource = new BehaviorSubject<any>({});

  getDataCapitalsInfo$ = this.dataCapitalsMarketSource.asObservable();
  constructor() { }
  /**
   * [setData]
   * @param data
   * @param origin
   */
  setDataCapitals(data: any, origin: string) {
    const objSend = {
      data: data,
      origin: origin,
    };

    this.dataCapitalsMarketSource.next(objSend);
  }


}
